module.exports = __webpack_public_path__ + "img/logo06.744e625.jpg";